import ParagraphSkeleton from '@/components/skeletons/ParagraphSkeleton';
import ArticleCardSkeleton from './ArticleCardSkeleton';

const ArticleSkeleton = () => {
  return (
    <article className=''>
      <div role='status' className='space-y-8 animate-pulse mx-auto'>
        <div className='relative flex flex-col mx-auto justify-center'>
          <div className='justify-center w-full h-[180px] md:h-[190px] bg-gray-100 rounded'>
            <div className='absolute left-[50%] translate-x-[-50%] px-4 md:container mx-auto py-7 md:py-12 w-full'>
              <div className='flex gap-2'>
                <div className='rounded h-[17px] w-[125px] bg-gray-300 animate-pulse' />
                <div className='rounded h-[17px] w-[90px] bg-gray-300 animate-pulse' />
              </div>
              <div className='mt-6 rounded h-[28px] md:h-[32px] w-[100%] md:w-[520px] md:max-w-[70%] bg-gray-300 animate-pulse' />
              <div className='mt-2 rounded h-[28px] md:h-[32px] w-[70%] md:hidden bg-gray-300 animate-pulse' />
            </div>
          </div>
          <div className='w-full flex flex-col md:gap-12 lg:justify-between mt-4 px-4 md:container md:flex-row mx-auto'>
            <div className='w-full lg:min-w-unset lg:!max-w-[840px]'>
              <div className='mt-3 mb-7 flex gap-2'>
                <div className='size-[48px] bg-gray-200 rounded-full' />
                <div className='mt-1'>
                  <div className='h-[14px] w-[160px] rounded bg-gray-200' />
                  <div className='mt-2 h-[14px] w-[120px] rounded bg-gray-200' />
                </div>
              </div>
              <ParagraphSkeleton />
              <ParagraphSkeleton />
              <ParagraphSkeleton />
            </div>
            <div className='hidden md:min-w-[360px] md:max-w-[360px] mt-4 justify-center w-full lg:flex flex-col gap-5'>
              <div className='rounded min-h-[28px] w-[220px] bg-gray-200 animate-pulse' />
              {Array.from({ length: 3 }, (_, index) => (
                <ArticleCardSkeleton background='grey' key={index} layout='noImage' />
              ))}
            </div>
          </div>
          <span className='sr-only'>Loading...</span>
        </div>
      </div>
    </article>
  );
};

export default ArticleSkeleton;
